<div class="tags-parent" *ngIf="currentLaguageId$ | async; let currentLaguageId">
    <div class="shadow-maker"></div>
    <app-tag-chip-select
        *ngIf="handlingTagIds"
        class="w-100 tags-wrap-on-the-fly"
        [language_id]="currentLaguageId"
        [formControl]="tagIdsControl"
        [removable]="canRemoveTags"
        (onTagClick)="onTagClick.emit($event)"
    ></app-tag-chip-select>
    <app-tag-item-chip-select
        *ngIf="!handlingTagIds"
        class="w-100 tags-wrap-on-the-fly"
        [language_id]="currentLaguageId"
        [formControl]="tagItemsControl"
        [removable]="canRemoveTags"
        (onTagClick)="onTagClick.emit($event)"
    ></app-tag-item-chip-select>
</div>
